import React, { useEffect, useState } from 'react';
import { Form, FormLabel } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../store';
import { setParams } from '../reducers/paramsReducer';

export default function GamesFiltersDates(): React.ReactNode {
  const { from, to } = useAppSelector((state) => state.paramsReducer.params);
  const dispatch = useAppDispatch();

  const [f, setF] = useState<string>();
  const [t, setT] = useState<string>();

  useEffect(() => {
    if (from) {
      setF(from);
    }
    if (to) {
      setT(to);
    }
  }, [from, to]);

  return (
    <div className="d-sm-inline d-md-flex">
      <div>
        <FormLabel className="d-block">From</FormLabel>
        <Form.Control
          as="input"
          type="date"
          placeholder="From"
          value={f ?? ''}
          width={40}
          onBlur={(event) => {
            dispatch(setParams({ from: event.target.value }));
          }}
          onChange={(event) => setF(event.target.value)}
        ></Form.Control>
      </div>
      <div>
        <FormLabel className="d-block">To</FormLabel>
        <Form.Control
          as="input"
          type="date"
          placeholder="To"
          value={t ?? ''}
          width={40}
          onBlur={(event) => {
            dispatch(setParams({ to: event.target.value }));
          }}
          onChange={(event) => setT(event.target.value)}
        ></Form.Control>
      </div>
    </div>
  );
}
